export const GrowthbookFeatureFlag = {
  SHOW_SUPERBAR: 'show-superbar',
} as const;
